var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.active && !_vm.addedCriteria.length
    ? _c(
        "button",
        {
          staticClass: "btn btn-default btn-secondary btn-sm",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.active = true
            },
          },
        },
        [_vm._v("\n\t" + _vm._s(_vm.$t("results.groupBy.groupResults")) + "\n")]
      )
    : _c(
        "div",
        { staticClass: "panel panel-primary" },
        [
          _c(
            "div",
            {
              staticClass: "panel-heading",
              staticStyle: {
                display: "flex",
                "align-items": "first baseline",
                gap: "0.25em",
              },
            },
            [
              _c(
                "h3",
                {
                  staticClass: "panel-title",
                  staticStyle: { "padding-right": "0.5em" },
                },
                [_vm._v(_vm._s(_vm.$t("results.groupBy.groupResults")))]
              ),
              _vm._v(" "),
              _vm.type === "hits"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.addAnnotation },
                    },
                    [
                      _vm._v(
                        "+ " + _vm._s(_vm.$t("results.groupBy.annotation"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: { click: _vm.addMetadata },
                },
                [_vm._v("+ " + _vm._s(_vm.$t("results.groupBy.metadata")))]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.tabs.length
            ? _c("Tabs", {
                staticStyle: { "margin-top": "6px", padding: "0 0.5em" },
                attrs: {
                  tabs: _vm.tabs,
                  wrap: "",
                  value: _vm.selectedCriteriumIndex,
                },
                on: {
                  input: function ($event) {
                    _vm.selectedCriteriumIndex = $event
                  },
                  middlemouse: function ($event) {
                    $event.index < _vm.addedCriteria.length &&
                      _vm.removeGroup($event.index)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "after",
                      fn: function ({ tab, i }) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link remove-group-button",
                              staticStyle: {
                                "align-self": "flex-start",
                                "margin-top": "-0.25em",
                                "font-size": "150%",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeGroup(i)
                                },
                              },
                            },
                            [
                              _c("strong", { staticClass: "text-danger" }, [
                                _vm._v("×"),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  239505536
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.addedCriteria.length || _vm.selectedCriterium
            ? _c(
                "div",
                { staticClass: "panel-body" },
                [
                  _vm.selectedCriterium?.type === "context"
                    ? [
                        _vm.isParallel
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "results.groupBy.parallelCorpusVersion"
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isParallel
                          ? _c("SelectPicker", {
                              attrs: {
                                options: _vm.parallelVersionOptions,
                                allowUnknownValues: "",
                                "data-width": "auto",
                                "data-menu-width": "auto",
                                hideEmpty: "",
                              },
                              model: {
                                value: _vm.fieldName,
                                callback: function ($$v) {
                                  _vm.fieldName = $$v
                                },
                                expression: "fieldName",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i18n", {
                          attrs: {
                            path: _vm.contextValue.startsWith(
                              _vm.OPT_PREFIX_SPAN_ATTRIBUTE
                            )
                              ? "results.groupBy.iWantToGroupOnNoAnnotation"
                              : "results.groupBy.iWantToGroupOnAnnotation",
                            tag: "div",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "some_words",
                                fn: function () {
                                  return [
                                    _c("SelectPicker", {
                                      attrs: {
                                        options: _vm.contextOptions,
                                        allowUnknownValues: "",
                                        "data-width": "auto",
                                        "data-menu-width": "auto",
                                        hideEmpty: "",
                                        allowHtml: "",
                                      },
                                      model: {
                                        value: _vm.contextValue,
                                        callback: function ($$v) {
                                          _vm.contextValue = $$v
                                        },
                                        expression: "contextValue",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "in_this_location_with_text",
                                fn: function () {
                                  return [
                                    _vm.selectedCriteriumAsPositional
                                      ? _c("i18n", {
                                          attrs: {
                                            path: "results.groupBy.in_this_location_with_text",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "in_this_location",
                                                fn: function () {
                                                  return [
                                                    _c("SelectPicker", {
                                                      attrs: {
                                                        hideEmpty: "",
                                                        "data-width": "auto",
                                                        "data-menu-width":
                                                          "auto",
                                                        options:
                                                          _vm.positionOptions,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.positionValue,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.positionValue =
                                                            $$v
                                                        },
                                                        expression:
                                                          "positionValue",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1645932492
                                          ),
                                        })
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "this_annotation",
                                fn: function () {
                                  return [
                                    _c("SelectPicker", {
                                      attrs: {
                                        placeholder:
                                          "..." + "\xa0".repeat(20) /*nbsp*/,
                                        "data-width": "auto",
                                        "data-menu-width": "auto",
                                        right: "",
                                        searchable: "",
                                        hideEmpty: "",
                                        options: _vm.annotations,
                                        allowHtml: "",
                                      },
                                      model: {
                                        value: _vm.selectedCriterium.annotation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selectedCriterium,
                                            "annotation",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "selectedCriterium.annotation",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3442980433
                          ),
                        }),
                        _vm._v(" "),
                        _c("form", { staticClass: "case-and-context" }, [
                          _c("div", { staticClass: "labels" }, [
                            _c(
                              "label",
                              { attrs: { for: "group-case-sensitive" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("results.groupBy.caseSensitive")
                                  ) + ": "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showRelationPartWidget
                              ? _c(
                                  "label",
                                  { attrs: { for: "group-relation" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.relationPartByClass("label")) +
                                        ":"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "inputs" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedCriterium.caseSensitive,
                                  expression: "selectedCriterium.caseSensitive",
                                },
                              ],
                              attrs: {
                                id: "group-case-sensitive",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.selectedCriterium.caseSensitive
                                )
                                  ? _vm._i(
                                      _vm.selectedCriterium.caseSensitive,
                                      null
                                    ) > -1
                                  : _vm.selectedCriterium.caseSensitive,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selectedCriterium.caseSensitive,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selectedCriterium,
                                          "caseSensitive",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selectedCriterium,
                                          "caseSensitive",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.selectedCriterium,
                                      "caseSensitive",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.showRelationPartWidget
                              ? _c("div", { staticClass: "btn-group" }, [
                                  _vm.relationSourceInThisField(
                                    _vm.relationMatchInfoDefByLabel(
                                      _vm.selectedCriteriumAsLabel
                                        ? _vm.selectedCriteriumAsLabel.context
                                            .label
                                        : ""
                                    )
                                  )
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default btn-sm",
                                          class: {
                                            active:
                                              _vm.selectedCriterium.context
                                                .type === "label" &&
                                              _vm.selectedCriterium.context
                                                .relation === "source",
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedCriterium.context.relation =
                                                "source"
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.relationPartByClass("source")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.relationTargetInThisField(
                                    _vm.relationMatchInfoDefByLabel(
                                      _vm.selectedCriteriumAsLabel
                                        ? _vm.selectedCriteriumAsLabel.context
                                            .label
                                        : ""
                                    )
                                  )
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default btn-sm",
                                          class: {
                                            active:
                                              _vm.selectedCriterium.context
                                                .type === "label" &&
                                              _vm.selectedCriterium.context
                                                .relation === "target",
                                          },
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedCriterium.context.relation =
                                                "target"
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.relationPartByClass("target")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.sliderVisible
                          ? _c(
                              "div",
                              { staticStyle: { padding: "10px 0 25px" } },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "results.groupBy.chooseWordPositions"
                                      )
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("Slider", {
                                  attrs: {
                                    direction: _vm.sliderInverted
                                      ? "rtl"
                                      : "ltr",
                                    inline: "",
                                    min: 1,
                                    max: _vm.contextsize,
                                    data: _vm.sliderLabels,
                                  },
                                  model: {
                                    value: _vm.sliderValue,
                                    callback: function ($$v) {
                                      _vm.sliderValue = $$v
                                    },
                                    expression: "sliderValue",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.relations.length + _vm.captures.length
                          ? _c("em", { staticClass: "text-muted" }, [
                              _c("span", {
                                staticClass:
                                  "fa fa-exclamation-triangle text-primary",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "results.groupBy.tipClickOnHighlightedWords"
                                    )
                                  ) +
                                  " ⤵"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm.selectedCriterium?.type === "metadata"
                    ? [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(
                              _vm.$t("results.groupBy.selectDocumentMetadata")
                            )
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("SelectPicker", {
                          attrs: {
                            placeholder: _vm.$t("results.groupBy.metadata"),
                            allowHtml: "",
                            hideEmpty: "",
                            "data-width": "auto",
                            "data-menu-width": "auto",
                            options: _vm.metadata,
                          },
                          model: {
                            value: _vm.selectedCriterium.field,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedCriterium, "field", $$v)
                            },
                            expression: "selectedCriterium.field",
                          },
                        }),
                        _vm._v(" "),
                        _c("form", { staticClass: "case-and-context" }, [
                          _c("div", { staticClass: "labels" }, [
                            _c(
                              "label",
                              { attrs: { for: "group-case-sensitive" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("results.groupBy.caseSensitive")
                                  ) + ": "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "inputs" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedCriterium.caseSensitive,
                                  expression: "selectedCriterium.caseSensitive",
                                },
                              ],
                              attrs: {
                                id: "group-case-sensitive",
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.selectedCriterium.caseSensitive
                                )
                                  ? _vm._i(
                                      _vm.selectedCriterium.caseSensitive,
                                      null
                                    ) > -1
                                  : _vm.selectedCriterium.caseSensitive,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selectedCriterium.caseSensitive,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selectedCriterium,
                                          "caseSensitive",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selectedCriterium,
                                          "caseSensitive",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.selectedCriterium,
                                      "caseSensitive",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]
                    : _vm.selectedCriterium?.type === "custom"
                    ? [
                        _vm._v(
                          "\n\t\t\t" +
                            _vm._s(_vm.selectedCriterium.value) +
                            "\n\t\t"
                        ),
                      ]
                    : _c("em", { staticClass: "h5 text-muted" }, [
                        _vm._v(
                          _vm._s(_vm.$t("results.groupBy.clickButtonsToStart"))
                        ),
                      ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCriterium?.type === "context"
            ? _c(
                "div",
                { staticClass: "hit-preview panel-footer" },
                [
                  _vm._l(_vm.preview, function (section, i) {
                    return [
                      i !== 0
                        ? _c("div", { staticClass: "separator" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        section,
                        function (
                          { selectedAnnotation, word, punct, active, style },
                          j
                        ) {
                          return [
                            _c(
                              active ? "section" : "div",
                              {
                                key: word + i + "_" + j,
                                tag: "component",
                                class: {
                                  word: true,
                                  active: active,
                                  "text-primary": active,
                                  bold: i === 1,
                                },
                                style: style,
                                on: {
                                  click: function ($event) {
                                    return _vm.handlePreviewClick($event, i, j)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "main",
                                    attrs: { title: word },
                                  },
                                  [_vm._v(_vm._s(word))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "annotation",
                                    attrs: { title: selectedAnnotation },
                                  },
                                  [_vm._v(_vm._s(selectedAnnotation))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              active && section[j + 1]?.active
                                ? "section"
                                : "div",
                              {
                                tag: "component",
                                class: {
                                  punct: true,
                                  active: active && section[j + 1]?.active,
                                },
                                attrs: { title: punct },
                              },
                              [_vm._v(_vm._s(punct || " "))]
                            ),
                          ]
                        }
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "panel-footer text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button", disabled: _vm.disabled },
                on: { click: _vm.clear },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.addedCriteria.length
                      ? _vm.$t("results.groupBy.clear")
                      : _vm.$t("results.groupBy.close")
                  )
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled: _vm.disabled || !_vm.addedCriteria.length,
                },
                on: { click: _vm.apply },
              },
              [_vm._v(_vm._s(_vm.$t("results.groupBy.apply")))]
            ),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }